import { styled, Typography } from "@mui/material";

export const deleteBorder = (index: number, isOpen: number) => (isOpen === index ? { borderBottom: "none" } : {});

export const SectionContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    paddingTop: 0,
    paddingBottom: theme.spacing(8),
}));

export const SectionHeader = styled(Typography)(({ theme }) => ({
    fontSize: 20,
    lineHeight: "23.94px",
    padding: theme.spacing(3),
    paddingLeft: theme.spacing(4),
    borderBottom: `1px solid ${theme.palette.emteria.border.primary}`,
    margin: 0,
    flexShrink: 0,
    width: "100%",
}));

export const SectionDescription = styled(Typography)(({ theme }) => ({
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(4),
    paddingBottom: theme.spacing(3),
    margin: 0,
    flexShrink: 0,
}));

export const Row = styled("div")(({ theme }) => ({
    display: "flex",
    gap: 8,
    paddingBottom: theme.spacing(2),
}));

export const ContentContainer = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(6),
    padding: theme.spacing(6),
    borderRadius: 6,
    backgroundColor: theme.palette.emteria.text.inverse,
}));
